import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@nimbus-ds/components';
import { HeaderInterface } from './Header/Header';
import BaseAppLayout from './BaseAppLayout';
import Header from './Header';

interface AppLayoutInterface extends HeaderInterface {
  children: React.ReactNode;
  footer?: React.ReactNode;
  skeleton?: boolean;
  maxWidth?: string;
}

function AppLayout(props: AppLayoutInterface): JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseAppLayout maxWidth={props.maxWidth}>
      <Header
        backLinkPath={props.backLinkPath}
        backLinkText={props.backLinkText ?? t('appLayout.backLinkText')}
        headerItems={props.headerItems}
        hideBackButton={props.hideBackButton}
        title={props.title}
        subtitle={props.subtitle}
        subtitleItems={props.subtitleItems}
        navBarItems={props.navBarItems}
        skeleton={props.skeleton}
      />
      <Box>{props.children}</Box>
      {props.footer && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          gap="4"
        >
          {props.footer}
        </Box>
      )}
    </BaseAppLayout>
  );
}

export default AppLayout;
